var _style, _path, _path2, _path3, _path4, _path5, _g, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#858186}.st1{fill:#ff6868}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.4 27.1c0-6.9-4.9-12.8-11.6-14.2-.4-.1-.8.2-.9.5-.2.9-.7 1.9-1.2 2.6H20.6c-.6-.9-1.1-1.9-1.3-2.9-.1-.3-.4-.6-.7-.6h-.4c-.5 0-1 0-1.6.1-1.5-3.3-4.5-4.8-8.5-4.2-.2 0-.4.2-.5.4s-.1.4 0 .6c.1.2 1.7 4.3 2.3 5.7-2.4 1.7-4.3 4.2-5.3 7-1.2 0-2.3.4-3.2 1.2S0 25.3 0 26.4v3.1C0 32 2 34 4.5 34c.4 0 .7 0 1.1-.1 1.2 2.1 2.8 3.9 4.9 5.2l-.3 5.6c0 .2.1.4.2.5.1.1.3.2.5.2h7c.4 0 .7-.3.7-.7l.2-3.3h13.1c1.2 0 2.5-.2 3.7-.5l.2 3.8c0 .4.3.7.7.7h7c.2 0 .4-.1.5-.2s.2-.3.2-.5l-.5-9.4c1.8-2.4 2.7-5.2 2.7-8.2zM11.8 38.9c0-.3-.1-.5-.4-.7-2.2-1.3-3.9-3.2-5-5.4-.2-.3-.6-.5-.9-.4-1 .4-2 .3-2.8-.3-.8-.6-1.3-1.5-1.3-2.5v-3.1c0-1.6 1.3-3 3-3h.5c.4.1.7-.1.8-.5.9-2.9 2.8-5.4 5.4-7.1.3-.2.4-.6.3-.9 0 0-1.5-3.6-2.2-5.4 2.1-.1 4.9.5 6.2 3.9.1.3.5.5.8.5.6-.1 1.1-.1 1.7-.2.3 1.2.9 2.3 1.7 3.2.1.2.3.3.6.3H33c.2 0 .4-.1.6-.3.7-.8 1.2-1.8 1.5-2.8 5.8 1.5 9.8 6.7 9.8 12.6 0 2.8-.9 5.4-2.5 7.7-.1.1-.1.3-.1.5l.5 8.9h-5.6l-.2-4c0-.2-.1-.4-.3-.6-.2-.1-.4-.2-.6-.1-1.3.4-2.7.7-4.1.7H18c-.4 0-.7.3-.7.7l-.2 3.3h-5.6l.3-5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.5 22.5c-.3 0-.6-.3-.6-.6v-2.1c0-.3.3-.6.6-.6s.6.3.6.6v2.1c0 .3-.2.6-.6.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.5 22.6c-.4 0-.7-.3-.7-.7v-2.1c0-.4.3-.7.7-.7s.7.3.7.7v2.1c0 .4-.3.7-.7.7zm0-3.3c-.3 0-.5.2-.5.5v2.1c0 .3.2.5.5.5s.5-.2.5-.5v-2.1c.1-.2-.2-.5-.5-.5zM44.2 21.4c-.3 0-.5-.2-.6-.4-.1-.3.1-.7.4-.8l3.2-1c.3-.1.7.1.8.4.1.3-.1.7-.4.8l-3.2 1h-.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.2 21.4c-.3 0-.6-.2-.7-.5-.1-.4.1-.7.4-.9l3.2-1c.4-.1.7.1.9.4.1.4-.1.7-.4.9l-3.2 1c0 .1-.1.1-.2.1zm3.3-2.2h-.2l-3.2 1c-.3.1-.4.4-.3.7s.4.4.7.3l3.2-1c.3-.1.4-.4.3-.7-.1-.2-.3-.3-.5-.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.7 2.6c-5 0-9 4-9 9 0 .4 0 .7.1 1 0 .3.1.6.1.9.3 1.4.9 2.7 1.8 3.8.2 0 .3.3.6-.5h12.8c.2.8.6.5.6.5.8-1 1.4-2.2 1.7-3.5.1-.4.2-.7.2-1.1 0-.3.1-.7.1-1.1-.1-5-4.1-9-9-9zM20.6 16c-.6-.9-1.1-1.9-1.3-2.9 0-.2-.1-.4-.1-.8v-.8c0-4.1 3.4-7.5 7.5-7.5s7.5 3.4 7.5 7.5c0 .3 0 .6-.1.9 0 .3-.1.6-.2.9-.2.9-.7 2-1.2 2.7H20.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.4 7.7h-2.3c.4.3.7.8.8 1.4h1.5v.7h-1.5c-.1 1.4-1.3 2.3-3.1 2.4 1.1 1.1 2.3 2.6 3.5 4H27c-1.1-1.3-2.1-2.5-3.4-3.9v-.9h.8c1.5 0 2.3-.6 2.4-1.6h-3.2v-.7h3.1c-.2-.8-.9-1.2-2.2-1.2h-1V7h5.9v.7z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.7 16H17.6c-.4 0-.7.3-.7.7s.3.7.7.7h18.1c.4 0 .7-.3.7-.7s-.3-.7-.7-.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalary);
export default __webpack_public_path__ + "static/media/salary.85a59323f413703d60cc314feda01506.svg";
export { ForwardRef as ReactComponent };